export default __webpack_public_path__ + "static/media/Bruins.937eae9b.png";